import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConsumedHandoffSession, HandoffSession } from '../models/handoffSession';

type HandoffSessionStoreState = {
  data: ConsumedHandoffSession | HandoffSession | undefined;
};

const initialState: HandoffSessionStoreState = {
  data: undefined,
};

/* istanbul ignore next: because we do not test reducers */
export const handoffSessionSlice = createSlice({
  name: 'handoff-session',
  initialState,
  reducers: {
    createHandoffSessionSuccess: (state, action) => {
      state.data = action.payload;
    },
    consumeHandoffSessionSuccess: (state, action: PayloadAction<ConsumedHandoffSession>) => {
      state.data = action.payload;
    },
    resetHandoffSession: (state) => {
      state.data = undefined;
    },
    setHandoffSession: (state, action: PayloadAction<HandoffSession>) => {
      state.data = action.payload;
    },
  },
});

export const {
  consumeHandoffSessionSuccess,
  resetHandoffSession,
  createHandoffSessionSuccess,
  setHandoffSession,
} = handoffSessionSlice.actions;
